import { styled, darkTheme } from "~/ui/style/stitches.config";
import { motion } from "framer-motion";
import { trackEvent } from "~/api/analyticsApi";

interface TopAnnouncementProps {
  shouldShow: boolean;
}

// Set to false to hide the announcement, true to show it
const ANNOUNCEMENT_ENABLED = false;

export const TopAnnouncement = ({ shouldShow }: TopAnnouncementProps) => {
  const handleClick = () => {
    trackEvent("/home/pressed_top_bar");
    window.open("https://apps.apple.com/app/moonlight-interactive-tarot/id6748324838", "_blank");
  };

  if (!ANNOUNCEMENT_ENABLED) {
    return null;
  }

  return (
    <StyledAnnouncementWrapper
      animate={{
        opacity: shouldShow ? 1 : 0,
        height: shouldShow ? "auto" : 0
      }}
      transition={{ duration: 0.3 }}
    >
      <StyledTopAnnouncement onClick={handleClick}>
        <StyledNewBadge></StyledNewBadge>
        <span>🍏 Try our </span>
        <StyledLink className="ios-link">iOS app</StyledLink>
      </StyledTopAnnouncement>
    </StyledAnnouncementWrapper>
  );
};

const StyledAnnouncementWrapper = styled(motion.div, {
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  marginTop: "80px",
  marginBottom: "-80px",
  
  "@mobile": {
    marginTop: "70px",
    marginBottom: "-100px",
  }
});

const StyledTopAnnouncement = styled("div", {
  backgroundColor: "#fff",
  color: "#000",
  padding: "9px 30px",
  textAlign: "center",
  fontSize: "12px",
  cursor: "pointer",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  transition: "background-color 0.2s ease",
  borderRadius: "25px",
  [`.${darkTheme.className} &`]: { backgroundColor: "$surface", color: "$text", borderColor: "rgba(255, 255, 255, 0.3)" },
  whiteSpace: "nowrap",

  "&:hover": {
    opacity: "0.8",

    "& .ios-link": {
      opacity: 0.7,
    },
  },

  "@mobile": {
    fontSize: "11px",
    padding: "14px 24px",
  }
});

const StyledNewBadge = styled("span", {
  color: "rgb(218, 238, 161)",
  fontWeight: "600",
  marginRight: "4px",
  fontStyle: "italic",
});

const StyledLink = styled("span", {
  textDecoration: "underline",
  fontWeight: "500",
  transition: "opacity 0.2s ease",
});
